import { Transforms, Editor } from 'slate';
import getNode from '@atlas/tool/box/slate/getNode';
import isMultiLineTextBlock from '@atlas/tool/box/slate/isMultiLineTextBlock';
import isOneLineTextBlock from '@atlas/tool/box/slate/isOneLineTextBlock';
import type { SlateBlock, SlateLeaf } from '@atlas/renderer';

export function extractFirstLine(editor: Editor, blockIndex: number): SlateLeaf[] {
    const blockPath = [blockIndex];
    const block = getNode<SlateBlock>(editor, blockPath);
    if (!block) return [];

    if (isOneLineTextBlock(block)) {
        const { children } = block;
        Transforms.removeNodes(editor, { at: blockPath });
        return children;
    }

    if (!isMultiLineTextBlock(block)) return [];

    const endOfLineIndex = block.children.findIndex((leaf) => leaf.text.includes('\n'));

    if (endOfLineIndex === -1) {
        const { children } = block;
        Transforms.removeNodes(editor, { at: blockPath });
        return children;
    }

    const children = block.children.slice(0, endOfLineIndex);
    const lineBreakLeaf = block.children[endOfLineIndex];
    children.push({ ...lineBreakLeaf, text: lineBreakLeaf.text.split('\n')[0] });

    Transforms.delete(editor, {
        at: {
            anchor: { path: [blockIndex, 0], offset: 0 },
            focus: { path: [blockIndex, endOfLineIndex], offset: lineBreakLeaf.text.indexOf('\n') + 1 },
        },
    });

    return children;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractFirstLine', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
